export const ShareIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill='none'
            stroke-linecap='round'
            stroke-linejoin='round'
            stroke-width='32'
            d='M336 192h40a40 40 0 0140 40v192a40 40 0 01-40 40H136a40 40 0 01-40-40V232a40 40 0 0140-40h40m160-64l-80-80-80 80m80 193V48'
        ></path>
    </svg>
)

export const ShareIcon2 = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='6 5 17 12'
        fill='none'
        color='currentColor'
        style='transform:scaleX(-1);'
    >
        <path
            d='M16.535 2.75C15.9001 2.75 15.3854 3.24408 15.3854 3.85355V6.25H12.5208C9.21288 6.25 6.53125 8.82436 6.53125 12V14.5C6.53125 14.8561 6.79207 15.1631 7.15542 15.2347C7.51783 15.3061 7.88257 15.1237 8.02944 14.798C8.0716 14.7189 8.19253 14.4939 8.28616 14.3494C8.47414 14.0595 8.76538 13.6708 9.17347 13.283C9.98241 12.5142 11.2451 11.75 13.1157 11.75H15.3854V14.1464C15.3854 14.7559 15.9001 15.25 16.535 15.25C16.8398 15.25 17.1322 15.1337 17.3478 14.9268L22.08 10.3839C22.4623 10.0169 22.6771 9.51906 22.6771 9C22.6771 8.48094 22.4623 7.98315 22.08 7.61612L17.3478 3.07322C17.1322 2.86627 16.8398 2.75 16.535 2.75Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const AddToHomeIcon = (P: any) => (
    <svg viewBox='0 0 48 48' height={P.size || 25} width={P.size || 25}>
        <g id='12-add,-new,-plus,-square' fill='none' fill-rule='evenodd'>
            <path
                id='Shape'
                d='m37 6c2.6887547 0 5 2.17929398 5 5v26c0 2.6887547-2.1694226 5-5 5h-26c-2.6887547 0-5-2.2121036-5-5v-26c0-2.6887547 2.16932778-5 5-5zm-26 2c-1.59768088 0-3 1.27598443-3 3v26c0 1.5976809 1.28873722 3 3 3h26c1.5976809 0 3-1.2618781 3-3v-26c0-1.59768088-1.2821228-3-3-3zm13 7c.5128358 0 1 .4039088 1 1v7h7c.5522847 0 1 .4477153 1 1 0 .5128358-.4385792 1-1 1h-7v7c0 .5522847-.4477153 1-1 1-.5128358 0-1-.4095355-1-1v-7h-7c-.5522847 0-1-.4477153-1-1 0-.5128358.4256658-1 1-1h7v-7c0-.5522847.4477153-1 1-1z'
                fill='rgb(0,0,0)'
                fill-rule='nonzero'
            />
        </g>
    </svg>
)
